import { IComponentOptions } from "angular";
import { ContractInstanceNotesComponentController } from "./controller";

export const vsComponentName = "contractInstanceNotes";

export const contractInstanceNotesComponentOptions: IComponentOptions = {
  controller: ContractInstanceNotesComponentController,
  controllerAs: "notesController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    contract: "<",
  },
};
